export default {

    title: 'EPSG:28992',
    definition: '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs \n',
    extent: [-285401.92, 22598.08, 595401.9199999999, 903401.9199999999],
    worldExtent: [-1.65729160235431, 48.0405018704265, 11.2902578747914, 55.9136415748388]
}